


















































































































































































import Vue from "vue";
import IconButton from "@/components/IconButton.vue";
import Page from "@/components/Page.vue";

import store, { CashFlowStore } from "../services/CashFlowStore";
import CashFlowRiportEditTable from "../components/CashFlowRiportEditTable.vue";
import Report from "@/modules/powerBI/models/Report";
import FloatingScrollbar from "../components/FloatingScrollbar.vue";
import { t } from "@/plugins/i18n";

interface Data {
  store: CashFlowStore;

  editHeadName: boolean;
  editHeadRemark: boolean;
  stepperIndex: number;
  isReload: boolean;
  isNewCashFlow: boolean;
  isDelete: boolean;
  validateMessage: string | null;
  lastScrollPosition: number;

  showReport: boolean;
}

interface Methods {
  loadData(cashFlowRiportId: number): void;
  updateCashFlow(): void;
  reloadCashFlow(): void;
  createCashFlow(): void;
  removeCashFlow(): void;
  openBiReport(biReport: Report): void;
  exportToExcel(): void;
  stepBack(): void;
  stepFirst(): void;
  stepNext(): void;
  stepLast(): void;
  shareLink(): void;
}

interface Computed {
  validateData(): string;
}

export default Vue.extend<Data, Methods, {}, Computed>({
  components: {
    Page,
    IconButton,
    CashFlowRiportEditTable,
    FloatingScrollbar,
  },

  async beforeMount() {
    await store.loadBIReports();
    const cashFlowRiportId = Number(this.$route.params["cashFlowRiportId"]) || 1;
    await this.loadData(cashFlowRiportId);
    await store.loadUserPermissions();
  },

  data() {
    return {
      store,
      editHeadRemark: false,
      editHeadName: false,
      stepperIndex: 0,
      isReload: false,
      isNewCashFlow: false,
      isDelete: false,
      validateMessage: null,
      lastScrollPosition: 0,

      showReport: false,
    };
  },

  methods: {
    async updateCashFlow() {
      await store.updateCashFlowRiport();
      await this.loadData(this.store.cashFlowRiportHead.id);
    },
    async loadData(cashFlowRiportId) {
      const scrollTarget = (this.$refs.editTable as any)?.$refs.editTableContainer as HTMLElement;
      this.lastScrollPosition = scrollTarget?.scrollLeft || 0;

      this.store.loading = true; //TODO: Lehet ezt szebben is
      this.$nextTick(() => {
        const newScrollTarget = (this.$refs.editTable as any)?.$refs.editTableContainer as HTMLElement;
        if (newScrollTarget) newScrollTarget.scrollLeft = this.lastScrollPosition;
      });

      await store.loadCashFlowRiport(cashFlowRiportId);
      await store.loadCashFlowRiportGroups();
      await store.loadCashFlowRiportGroupItems();
      await store.loadGeneralLedgerRiportRowItems();
      await store.loadGeneralLedgerRiportRowsTransAmounts();
      await store.loadCashFlowRiportChain();
      this.stepperIndex = store.cashFlowRiportChain.findIndex(riport => riport.id == store.cashFlowRiportHead.id);

      this.store.loading = false;  //TODO: Lehet ezt szebben is
      console.log(this.store.nonProfitGroups);
      this.$nextTick(() => {
        const newScrollTarget = (this.$refs.editTable as any)?.$refs.editTableContainer as HTMLElement;
        if (newScrollTarget) newScrollTarget.scrollLeft = this.lastScrollPosition;
      });
    },
    reloadCashFlow() {
      this.isReload = this.isNewCashFlow = this.isDelete = false;
      this.loadData(this.store.cashFlowRiportHead.id);
    },
    async createCashFlow() {
      this.isReload = this.isNewCashFlow = this.isDelete = false;
      await store.createCashFlowRiport(this.store.cashFlowRiportHead.reportHead, (this.store.cashFlowRiportHead.year + 1), false, this.store.cashFlowRiportHead.id);
      await this.loadData(this.store.cashFlowRiportHead.id);
    },
    removeCashFlow() {
      this.isReload = this.isNewCashFlow = this.isDelete = false;
      store.removeCashFlowRiport(this.store.cashFlowRiportHead.id);
      this.loadData(this.store.cashFlowRiportChain[this.stepperIndex -1].id);
    },
    openBiReport(biReport) {
      const id = biReport.reportId;
      const paramId = biReport.paramId.toString();
      const routeData = this.$router.resolve({
        name: "PowerBIPage",
        params: { id, paramId }
      });
      window.open(routeData.href, "_blank");
    },
    exportToExcel() {
      //
    },
    stepBack() {
      this.isReload = this.isNewCashFlow = this.isDelete = false;
      this.loadData(this.store.cashFlowRiportChain[this.stepperIndex - 1].id);
    },
    stepFirst() {
      this.isReload = this.isNewCashFlow = this.isDelete = false;
      this.loadData(this.store.cashFlowRiportChain[0].id);
    },
    stepNext() {
      this.isReload = this.isNewCashFlow = this.isDelete = false;
      if ((this.stepperIndex + 1) < this.store.cashFlowRiportChain.length) {
        this.loadData(this.store.cashFlowRiportChain[this.stepperIndex + 1].id);
      }
      else {
        this.isNewCashFlow = !this.isNewCashFlow;
      }
    },
    stepLast() {
      this.isReload = this.isNewCashFlow = this.isDelete = false;
      this.loadData(this.store.cashFlowRiportChain[this.store.cashFlowRiportChain.length - 1].id);
    },
    shareLink() {
      const link = `${(window.location.origin + window.location.pathname).replace(/\/\d+$/, '')}/${store.cashFlowRiportHead.id}`;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(link)
          .then(() => {
            console.log('Copied!')
          })
          .catch(err => {
            console.error('Clipboard failed:', err)
          })
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = link
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        console.log('Copied!')
      }
    },
  },

  computed: {
    validateData() {
      let validateMessage = "";
      if (this.store.cashFlowRiportGroupItems.some(item => item.name.replace(/[\s-]+/g, "").length <= 1)) {
        validateMessage += t("CashFlowRiport_AzUjTetelekKozottVanOlyan")
      }
      if (this.store.generalLedgerRiportRowItems.some(item => item.accNo.replace(/[\s-]+/g, "").length <= 1)) {
        validateMessage += t("CashFlowRiport_AMaszkokKozottVanOlyanAmelyhez")
      }
      return validateMessage
    },
  }
});
